module.exports = __webpack_public_path__ + "img/video.7ec4421e.jpg";